
<div v-if="loading">
  <slot />
</div>
<div v-else-if="error">
  <slot
    name="error"
    :error="error"
  />
</div>
<iframe
  v-else
  ref="iframe"
  style="width: 100%; height: 100%; border: none;"
  :srcdoc="srcdoc"
  @load="addEventHandlers"
/>
